import { render, staticRenderFns } from "./GestantesIcon.vue?vue&type=template&id=1d2d8d4d"
import script from "./GestantesIcon.vue?vue&type=script&lang=js"
export * from "./GestantesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports